//
import React from 'react';
import { CheckboxList, TitledSection } from 'components';
import { CheckboxListItem } from 'components';
import { useFilterContext } from '../../context';
import { NavigationDeviceType } from 'features/myFleet/types';
import { useIntl } from 'react-intl';

export const DeviceTypeFilter = () => {
  const { formatMessage } = useIntl();
  const { deviceType, onChangeDeviceType } = useFilterContext();

  const options: CheckboxListItem[] = [
    {
      value: formatMessage({ id: 'eBoxDevice' }),
      key: 'EBox' as NavigationDeviceType,
    },
    {
      value: formatMessage({ id: 'e100MobileAppDevice' }),
      key: 'E100MobileApp' as NavigationDeviceType,
    },
  ];

  return (
    <TitledSection title={formatMessage({ id: 'deviceType' })} paddingBottom={1} bordered={false}>
      <CheckboxList state={deviceType} items={options} onChange={onChangeDeviceType} />
    </TitledSection>
  );
};
